import React from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";

const DeleteProduct = ({ handleDeleteCat }: any) => {
  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Delete Categories</h4>
          <ImCancelCircle className="catCancel" onClick={handleDeleteCat} />
        </div>
        <div className="line"></div>

        <div className="catModalInput branchInput">
          <div className="div modalDouble addProduct">
            <input type="text" placeholder="Product Name" />
            <input type="text" placeholder="Description" />
          </div>
          <div className="div modalDouble addProduct">
            <input type="text" placeholder="Unit Price" />
            <input type="text" placeholder="Quantity" />
          </div>
          <div className="div modalDouble addProduct">
            <input type="text" placeholder="Type/Category" />
            <input type="text" placeholder="Unit Of Measurment" />
          </div>
        </div>

        <div className="catModalBtn">
          <button className="catBtn1 delCat">Delete Catigory</button>
          <button className="catBtn2" onClick={handleDeleteCat}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteProduct;
